import { useSelector } from 'react-redux';
import { useMemo } from 'react';

/**
 * Hook: returns a merged securityForm where every “Attack Surface – *”
 * section becomes a multiselect (options = attack names) with an
 * `attributes` object copied from vulnerabilityAssessmentForm so the UI
 * can render it exactly like Threat Agents.
 */
export function useMergedSecurityForm() {
  // 1. Pull both configs from Redux
  const securityConfig = useSelector(
    s => s.config.configs['securityForm']?.security || []
  );
  const vulnSpec = useSelector(
    s => s.config.configs['vulnerabilityAssessmentForm'] || null
  );

  // 2. Compute attributes once
  const attributeObj = useMemo(() => {
    if (!vulnSpec) return {};
    const attrs = {};
    (vulnSpec.subcategories || []).forEach(v => {
      attrs[v.name] = {
        type: v.type,
        options: v.options,
        description: v.description
      };
    });
    return attrs;
  }, [vulnSpec]);

  // 3. Merge / transform
  return useMemo(() => {
    if (!vulnSpec) return securityConfig; // nothing to inject yet

    return securityConfig.map(section => {
      // Transform only Attack‑Surface sections
      if (
        typeof section.name === 'string' &&
        section.name.startsWith('Attack Surface') &&
        section.schema?.type === 'category'
      ) {
        const attackNames = (section.schema.subcategories || []).map(s => s.name);

        const deepClasses = {};
        (section.schema.subcategories || []).forEach(sub => {
         deepClasses[sub.name] = sub.options || [];
        });

        console.log('mergeUtil → transformed', section.name, 'into multiselect');
        return {
          name: section.name,
          schema: {
            type: 'multiselect',
            options: attackNames,
            attributes: attributeObj,
            deepClasses, 
            description: section.schema.description
          }
        };
      }

      // Pass‑through for all other sections
      return section;
    });
  }, [securityConfig, attributeObj, vulnSpec]);
}